export const admin = {
  layout: {
    home: 'Home',
  },
  
  sidebar: {
    dashboard: 'Dashboard',
    agencies: 'Agencies',
    cars: 'Cars',
    clients: 'Clients',
    bookings: 'Bookings',
    factures: 'Invoices',
    stats: 'Statistics',
    users: 'Users',
    vehicles: 'Vehicles',
    payments: 'Payments',
    reports: 'Reports',
    documents: 'Documents',
    security: 'Security',
    settings: 'Settings',
    help: 'Help & Support',
    brandsModels: 'Brands & Models',
  },
  
  // Dashboard
  title: 'Admin Dashboard',
  subtitle: 'Manage your KiraCar platform',
  
  // Overview
  totalUsers: 'Total Users',
  totalVehicles: 'Total Vehicles',
  monthlyRevenue: 'Monthly Revenue',
  platformActivity: 'Platform Activity',
  
  // Dashboard Cards (Root level for component access)
  totalAgencies: 'Total Agencies',
  active: 'active',
  totalCars: 'Total Cars',
  acrossAllAgencies: 'Across all agencies',
  totalRevenue: 'Total Revenue',
  allTimeRevenue: 'All-time revenue',
  selected: 'Selected',
  searchAgencies: 'Search agencies',
  columns: 'Columns',
  showingAgencies: 'Showing {{count}} of {{total}} agencies',
  allCities: 'All Cities',
  filters: 'Filters',
  
  // Cars Admin Page Keys
  totalBookings: 'Total Bookings',
  acrossAllCars: 'Across all cars',
  available: 'Available',
  allAgencies: 'All Agencies',
  allCategories: 'All Categories',
  searchCars: 'Search cars',
  
  // Additional Agency Admin Keys
  allAgencyLocations: 'All agency locations',
  allReviewsAndRatings: 'All reviews and ratings',
  allNotifications: 'All notifications',
  
  // Agency Deletion Dialog Keys
  cancel: 'Cancel',
  yesDeleteEverything: 'Yes, delete everything',
  
  // Clients Admin Page Keys
  verifiedClients: 'Verified Clients',
  totalClients: 'Total Clients',
  searchClients: 'Search clients',
  showingClients: 'Showing {{count}} of {{total}} clients',
  allVerification: 'All Verification',
  fromAllClients: 'From all clients',
  
  // Users
  userManagement: 'User Management',
  agencyOwners: 'Agency Owners',
  administrators: 'Administrators',
  
  // Common actions
  view: 'View',
  edit: 'Edit',
  delete: 'Delete',
  approve: 'Approve',
  reject: 'Reject',
  activate: 'Activate',
  deactivate: 'Deactivate',
  
    // Common buttons
    export: 'Export',
    download: 'Download',
    save: 'Save',
    saveChanges: 'Save Changes',
    close: 'Close',
    changePassword: 'Change Password',
    mustBeLoggedIn: 'You must be logged in to perform this action.',
    cancelSelected: 'Cancel Selected',
    refresh: 'Refresh',
    markCompleted: 'Mark Completed',
    sendSelected: 'Send Selected',
    markAsPaid: 'Mark as Paid',
    viewInvoice: 'View Invoice',
    sendToCustomer: 'Send to Customer',
    editInvoice: 'Edit Invoice',
    editAgency: 'Edit Agency',
    editClient: 'Edit Client',
    editBooking: 'Edit Booking',
    deleteCar: 'Delete Car',
    deleteBooking: 'Delete Booking',
    addAgency: 'Add Agency',
    addCar: 'Add Car',
    addBooking: 'Add Booking',
    addClient: 'Add Client',
    createInvoice: 'Create Invoice',
    create: 'Create',
  actions: 'Actions',
  areYouSure: 'Are you sure',
  actionCannotBeUndone: 'This action cannot be undone',
  willPermanentlyDelete: 'This will permanently delete',
  areYouAbsolutelySure: 'Are you absolutely sure?',
  deleteClient: 'Delete Client',
  andAllOf: 'and all of',
  andAllOfTheir: 'and all of their',
  associatedData: 'associated data',
  for: 'for',
  manageAndTrack: 'Manage and track all invoices and payments',
  editingDetailsFor: 'Editing details for',
  viewingDetailsFor: 'Viewing details for',
  editingBookingFor: 'Editing booking for',
  viewingBookingDetailsFor: 'Viewing booking details for',
  theFollowingWillBeDeleted: 'The following will be deleted:',
  bookingFor: 'Booking for',
  hasBeenPermanentlyDeleted: 'has been permanently deleted',
  invoice: 'INVOICE',
  bookingId: 'Booking ID',
  customer: 'Customer',
  email: 'Email',
  vehicle: 'Vehicle',
  startDate: 'Start Date',
  endDate: 'End Date',
  duration: 'Duration',
  totalAmount: 'Total Amount',
  days: 'days',
  emailSelected: 'Email Selected',
  avgDuration: 'Avg Duration',
  fullName: 'Full Name',
  phone: 'Phone',
  username: 'Username',
  averageRentalPeriod: 'Average rental period',
  blockSelected: 'Block Selected',
  deleteSelected: 'Delete Selected',
  amount: 'Amount',
  paymentStatus: 'Payment Status',
  generated: 'Generated',
  role: 'Role',
  agencyName: 'Agency Name',
  country: 'Country',
  address: 'Address',
  description: 'Description',
  notes: 'Notes',
  durationDays: 'Duration (days)',
  addNotesPlaceholder: 'Add any notes about this booking...',
  noDescriptionProvided: 'No description provided.',
  generatingInvoice: 'Generating invoice...',
  unknownCustomer: 'Unknown Customer',
  notAvailable: 'N/A',
  allStatus: 'All Status',
  noEmail: 'No email',
  unknownAgency: 'Unknown Agency',
  bookingsByStatus: 'Bookings by Status',

  dashboard: {
    title: 'Admin Dashboard',
    overview: 'Overview',
    customers: 'Customers',
    agencies: 'Agencies',
    vehicles: 'Vehicles',
    analytics: 'Analytics',
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
    newAgencyRegistered: 'New Agency Registered',
    agencyJoinedPlatform: 'A new agency joined the platform',
    vehicleAdded: 'Vehicle Added',
    vehicleAddedToInventory: 'New vehicle added to inventory',
    bookingCompleted: 'Booking Completed',
    customerCompletedRental: 'Customer completed rental',
    userVerification: 'User Verification',
    newUserVerified: 'New user account verified',
    hoursAgo: '{{count}} hours ago',
    manageCustomers: 'Manage Customers',
    manageAgencies: 'Manage Agencies',
    manageVehicles: 'Manage Vehicles',
    viewAnalytics: 'View Analytics',
    agencyManagement: 'Agency Management',
    agencyManagementDesc: 'Manage and monitor all rental agencies on the platform',
    addNewAgency: 'Add New Agency',
    vehicleManagement: 'Vehicle Management',
    vehicleManagementDesc: 'Manage and monitor all vehicles across agencies',
    addNewVehicle: 'Add New Vehicle',
    
    // Dashboard Cards
    totalUsers: 'Total Users',
    registeredUsers: 'Registered users on platform',
    totalAgencies: 'Total Agencies',
    active: 'active',
    activeAgencies: 'Active rental agencies',
    totalCars: 'Total Cars',
    acrossAllAgencies: 'Across all agencies',
    totalVehicles: 'Total Vehicles',
    availableVehicles: 'Available vehicles',
    totalRevenue: 'Total Revenue',
    allTimeRevenue: 'All-time revenue',
    completedBookings: 'From completed bookings',
    selected: 'Selected',
    ofSelected: 'of {{total}} selected',
    totalBookings: 'Total Bookings',
    allTimeBookings: 'All-time bookings',
    activeBookings: 'Active Bookings',
    currentlyActive: 'Currently active',
    pendingBookings: 'Pending Bookings',
    awaitingConfirmation: 'Awaiting confirmation',
    totalLocations: 'Total Locations',
    agencyLocations: 'Agency locations',
    fromLastMonth: 'from last month',
    statsError: 'Error loading stats'
  },
  
  analytics: {
    errorTitle: 'Analytics Error',
    retry: 'Retry',
    topAgency: 'Top Agency',
    byRevenue: 'By revenue',
    topCategory: 'Top Category',
    mostPopular: 'Most popular',
    avgBookingValue: 'Avg Booking Value',
    perBooking: 'Per booking',
    conversionRate: 'Conversion Rate',
    visitorsToBookings: 'Visitors to bookings',
    agencyPerformance: 'Agency Performance',
    vehicles: 'Vehicles',
    bookings: 'Bookings',
    revenue: 'Revenue',
    rating: 'Rating',
    completion: 'Completion',
    categoryDistribution: 'Category Distribution'
  },
  
  agencies: {
    title: 'Agency Management',
    subtitle: 'Manage and monitor all rental agencies',
    all: 'All',
    active: 'Active',
    pending: 'Pending',
    suspended: 'Suspended',
    searchAgencies: 'Search agencies',
    allStatus: 'All Status',
    allCities: 'All Cities',
    filters: 'Filters',
    columns: 'Columns',
    showingAgencies: 'Showing {{count}} of {{total}} agencies',
    errorTitle: 'Failed to Load Agencies',
    retry: 'Retry',
    website: 'Website',
    vehicles: 'Vehicles',
    bookings: 'Bookings',
    revenue: 'Revenue',
    rating: 'Rating',
    completion: 'Completion',
    lastActivity: 'Last Activity',
    joinedOn: 'Joined on',
    locations: 'Locations',
    more: 'more',
    noAgencies: 'No Agencies Found',
    noAgenciesDesc: 'No agencies match the current filters',
    yesterday: 'Yesterday',
    daysAgo: '{{count}} days ago',
    weeksAgo: '{{count}} weeks ago',
    monthsAgo: '{{count}} months ago',
    
    // Table columns
    name: 'Agency Name',
    email: 'Email',
    phone: 'Phone',
    city: 'City',
    country: 'Country',
    cars: 'Cars',
    status: 'Status',
    username: 'Username',
    address: 'Address',
    
    // Actions
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    actions: 'Actions',
    
    // Dialog
    agencyDetails: 'Agency Details',
    editAgency: 'Edit Agency',
    noUsername: 'No username',
    
    // Messages
    fetchError: 'Failed to fetch agencies',
    deleteError: 'Failed to delete agency',
    deleteSuccess: 'Agency deleted successfully',
    updateSuccess: 'Agency updated successfully',
    updateError: 'Failed to update agency',
    deleteFailed: 'Failed to delete agency',
    permissionDenied: 'Permission denied. You may not have the necessary rights to delete this agency.',
    
    // Common placeholders
    min: 'Min',
    max: 'Max',
    
    // Password management
    newPassword: 'New Password',
    enterNewPassword: 'Enter new password (min. 6 characters)',
    passwordHint: 'Leave empty to keep current password. Minimum 6 characters.',
    generatePassword: 'Generate Random Password',
    sendPasswordEmail: 'Send Password to Email',
    passwordRequired: 'Please generate or enter a password first.',
    passwordTooShort: 'Password must be at least 6 characters long.',
    ownerNotFound: 'Could not find agency owner.',
    ownerEmailNotFound: 'Could not find owner email address.',
    emailSendFailed: 'Failed to send email',
    passwordEmailSent: 'Password has been sent to the agency owner\'s email.',
    emailSendError: 'Failed to send password email. Please try again.'
  },
  
  vehicles: {
    title: 'Vehicle Management',
    subtitle: 'Manage and monitor all vehicles across agencies',
    totalVehicles: 'Total Vehicles',
    acrossAllAgencies: 'Across all agencies',
    averagePrice: 'Average Price',
    perDay: 'Per day',
    utilization: 'Utilization Rate',
    averageUtilization: 'Average utilization',
    topCategory: 'Top Category',
    mostPopular: 'Most popular',
    allCategories: 'All Categories',
    all: 'All',
    available: 'Available',
    rented: 'Rented',
    maintenance: 'Maintenance',
    unavailable: 'Unavailable',
    errorTitle: 'Failed to Load Vehicles',
    retry: 'Retry',
    seats: 'seats',
    bookings: 'Bookings',
    revenue: 'Revenue',
    rating: 'Rating',
    lastBooked: 'Last Booked',
    noVehicles: 'No Vehicles Found',
    noVehiclesDesc: 'No vehicles match the current filters',
    yesterday: 'Yesterday',
    daysAgo: '{{count}} days ago',
    weeksAgo: '{{count}} weeks ago',
    monthsAgo: '{{count}} months ago'
  },

  cars: {
    title: 'Cars',
    subtitle: 'Manage and monitor all cars across agencies',
    totalCars: 'Total Cars',
    acrossAllAgencies: 'Across all agencies',
    averagePrice: 'Average Price',
    perDay: 'Per day',
    utilization: 'Utilization Rate',
    averageUtilization: 'Average utilization',
    topCategory: 'Top Category',
    mostPopular: 'Most popular',
    allCategories: 'All Categories',
    all: 'All',
    available: 'Available',
    rented: 'Rented',
    maintenance: 'Maintenance',
    unavailable: 'Unavailable',
    errorTitle: 'Failed to Load Cars',
    retry: 'Retry',
    seats: 'seats',
    bookings: 'Bookings',
    revenue: 'Revenue',
    rating: 'Rating',
    lastBooked: 'Last Booked',
    noCars: 'No Cars Found',
    noCarsDesc: 'No cars match the current filters',
    yesterday: 'Yesterday',
    daysAgo: '{{count}} days ago',
    weeksAgo: '{{count}} weeks ago',
    monthsAgo: '{{count}} months ago',
    
    // Table columns
    make: 'Make',
    model: 'Model',
    year: 'Year',
    color: 'Color',
    category: 'Category',
    transmission: 'Transmission',
    fuelType: 'Fuel Type',
    pricePerDay: 'Price/Day',
    availability: 'Available',
    agency: 'Agency',
    bookingCount: 'Bookings',
    created: 'Created',
    
    // Actions
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    actions: 'Actions',
    
    // Dialog
    carDetails: 'Car Details',
    editCar: 'Edit Car',
    viewCarInfo: 'View detailed information about this car',
    editCarInfo: 'Edit car information',
    description: 'Description',
    noDescription: 'No description',
    selectTransmission: 'Select transmission',
    selectAvailability: 'Select availability',
    close: 'Close',
    cancel: 'Cancel',
    save: 'Save',
    deleting: 'Deleting...',
    deleteCar: 'Delete Car',
    
    // Messages
    fetchError: 'Failed to fetch cars',
    deleteError: 'Cannot delete car with active bookings',
    deleteSuccess: 'Car deleted successfully',
    updateSuccess: 'Car updated successfully',
    updateError: 'Failed to update car',
    deleteFailed: 'Failed to delete car',
    
    // CSV Export
    csvHeaders: ['Make', 'Model', 'Year', 'Color', 'Category', 'Transmission', 'Fuel Type', 'Seats', 'Price/Day', 'Agency', 'Bookings', 'Revenue', 'Status', 'Created']
  },
  
  customers: {
    title: 'Customer Management',
    subtitle: 'Manage and monitor all customers',
    totalCustomers: 'Total Customers',
    activeCustomers: 'Active Customers',
    verifiedCustomers: 'Verified Customers',
    newThisMonth: 'New this month',
    errorTitle: 'Failed to Load Customers',
    retry: 'Retry'
  },

  bookings: {
    title: 'Bookings',
    subtitle: 'Manage and monitor all bookings',
    totalBookings: 'Total Bookings',
    activeBookings: 'Active Bookings',
    completedBookings: 'Completed Bookings',
    cancelledBookings: 'Cancelled Bookings',
    errorTitle: 'Failed to Load Bookings',
    retry: 'Retry',
    
    // Table columns
    bookingId: 'Booking ID',
    customer: 'Customer',
    agency: 'Agency',
    carMake: 'Car Make',
    carModel: 'Car Model',
    startDate: 'Start Date',
    endDate: 'End Date',
    duration: 'Duration',
    amount: 'Amount',
    status: 'Status',
    payment: 'Payment',
    created: 'Created',
    customerEmail: 'Customer Email',
    pickupLocation: 'Pickup Location',
    returnLocation: 'Return Location',
    
    // Status labels
    pending: 'Pending',
    confirmed: 'Confirmed',
    active: 'Active',
    completed: 'Completed',
    cancelled: 'Cancelled',
    
    // Payment status
    paid: 'Paid',
    failed: 'Failed',
    refunded: 'Refunded',
    
    // Actions
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    actions: 'Actions',
    downloadInvoice: 'Download Invoice',
    markCompleted: 'Mark Completed',
    cancel: 'Cancel',
    resendWhatsApp: 'Resend WhatsApp',
    
    // Resend WhatsApp dialog
    resendWhatsAppTitle: 'Resend WhatsApp Notification',
    resendWhatsAppDescription: 'Edit the template variables below and send the new booking notification to the agency owner.',
    resendWhatsAppBooking: 'Booking',
    resendWhatsAppSend: 'Send WhatsApp',
    whatsappVarId: 'ID',
    whatsappVarClient: 'Client',
    whatsappVarCarMake: 'Car Make',
    whatsappVarCarModel: 'Car Model',
    whatsappVarDepart: 'Départ (date)',
    whatsappVarRetour: 'Retour (date)',
    whatsappVarPrix: 'Prix Total',
    whatsappVarTele: 'Télé',
    
    // Dialog
    bookingDetails: 'Booking Details',
    editBooking: 'Edit Booking',
    selectStatus: 'Select status',
    selectPaymentStatus: 'Select payment status',
    
    // Messages
    fetchError: 'Failed to fetch bookings',
    deleteError: 'Failed to delete booking',
    deleteSuccess: 'Booking deleted successfully',
    updateSuccess: 'Booking updated successfully',
    updateError: 'Failed to update booking',
    deleteFailed: 'Failed to delete booking',
    permissionDenied: 'Permission denied. You may not have the necessary rights to delete this booking.',
    bookingDataNotFound: 'Booking data not found',
    invoiceDownloaded: 'Invoice downloaded successfully',
    bookingCompleted: 'Booking marked as completed',
    bookingCancelled: 'Booking cancelled',
    whatsappNotificationFailed: 'Booking created but WhatsApp notification failed',
    whatsappResendSuccess: 'WhatsApp notification sent successfully',
    
    // Placeholders
    noCustomer: 'No Customer',
    noEmail: 'No email',
    unknownAgency: 'Unknown Agency',
    unknown: 'Unknown',
    notSpecified: 'Not specified',
    
    // Common placeholders
    min: 'Min',
    max: 'Max',
    
    // Booking creation dialog
    createBooking: 'Create Booking',
    createBookingDescription: 'Create a new booking for any agency',
    selectAgency: 'Select Agency',
    selectCustomer: 'Select Customer',
    selectCar: 'Select Car',
    agencyRequired: 'Agency is required',
    customerRequired: 'Customer is required',
    carRequired: 'Car is required',
    datesRequired: 'Start and end dates are required',
    startTime: 'Start Time',
    endTime: 'End Time',
    calculatePrice: 'Calculate Price',
    bookingCreated: 'Booking created successfully',
    createBookingError: 'Failed to create booking',
    totalPrice: 'Total Price',
    createNewCustomer: 'Create New Customer',
    customerName: 'Customer Name',
    customerPhone: 'Customer Phone',
    noAgenciesFound: 'No agencies found',
    noCustomersFound: 'No customers found',
    noCarsFound: 'No cars found for selected agency',
    pricePerDay: 'Price per day'
  },
  
  users: {
    title: 'User Management',
    management: 'User Management',
    subtitle: 'Manage and monitor all platform users'
  },

  clients: {
    title: 'Clients',
    subtitle: 'Manage and monitor all clients',
    totalClients: 'Total Clients',
    activeClients: 'Active Clients',
    verifiedClients: 'Verified Clients',
    newThisMonth: 'New this month',
    errorTitle: 'Failed to Load Clients',
    retry: 'Retry',
    
    // Table columns
    clientName: 'Client Name',
    email: 'Email',
    phone: 'Phone',
    bookings: 'Bookings',
    totalSpent: 'Total Spent',
    lastBooking: 'Last Booking',
    status: 'Status',
    verification: 'Verification',
    joined: 'Joined',
    role: 'Role',
    
    // Status labels
    active: 'Active',
    inactive: 'Inactive',
    suspended: 'Suspended',
    
    // Verification status
    verified: 'Verified',
    unverified: 'Unverified',
    pending: 'Pending',
    
    // Actions
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    actions: 'Actions',
    
    // Dialog
    clientDetails: 'Client Details',
    editClient: 'Edit Client',
    
    // Messages
    fetchError: 'Failed to fetch clients',
    deleteError: 'Failed to delete client',
    deleteSuccess: 'Client deleted successfully',
    updateSuccess: 'Client updated successfully',
    updateError: 'Failed to update client',
    deleteFailed: 'Failed to delete client',
    permissionDenied: 'Permission denied. You may not have the necessary rights to delete this client.',
    
    // Placeholders
    client: 'Client',
    noName: 'No name',
    noPhone: 'No phone',
    never: 'Never',
    
    // Common placeholders
    min: 'Min',
    max: 'Max'
  },
  
  settings: {
    title: 'Admin Settings',
    subtitle: 'Configure platform settings and preferences',
    general: 'General',
    platform: 'Platform',
    security: 'Security',
    notifications: 'Notifications',
    
    // General Settings
    platformName: 'Platform Name',
    platformDescription: 'Platform Description',
    defaultLanguage: 'Default Language',
    timezone: 'Timezone',
    currency: 'Default Currency',
    
    // Platform Settings
    maintenanceMode: 'Maintenance Mode',
    maintenanceModeDesc: 'Enable maintenance mode to prevent user access',
    userRegistration: 'User Registration',
    userRegistrationDesc: 'Allow new users to register on the platform',
    agencyRegistration: 'Agency Registration',
    agencyRegistrationDesc: 'Allow new agencies to register on the platform',
    
    // Security Settings
    passwordPolicy: 'Password Policy',
    passwordPolicyDesc: 'Configure password requirements',
    twoFactorAuth: 'Two-Factor Authentication',
    twoFactorAuthDesc: 'Require 2FA for admin accounts',
    emailVerification: 'Email Verification',
    emailVerificationDesc: 'Require email verification for new user signups',
    sessionTimeout: 'Session Timeout',
    sessionTimeoutDesc: 'Automatically log out inactive users',
    
    // Notification Settings
    emailNotifications: 'Email Notifications',
    emailNotificationsDesc: 'Send email notifications for important events',
    smsNotifications: 'SMS Notifications',
    smsNotificationsDesc: 'Send SMS notifications for critical alerts',
    
    // Watermark Settings
    watermark: 'Image Watermark',
    watermarkEnabled: 'Enable Watermark',
    watermarkEnabledDesc: 'Add watermark to all car images',
    watermarkImage: 'Watermark Image',
    watermarkChangeImage: 'Change Image',
    watermarkUploadImage: 'Upload Image',
    watermarkUpload: 'Upload',
    watermarkUploading: 'Uploading...',
    watermarkImageUploaded: 'Watermark image uploaded successfully',
    watermarkImageLoadError: 'Image not found',
    watermarkRemove: 'Remove',
    watermarkImageHelp: 'Recommended: PNG with transparent background, max 5MB. The watermark will maintain its aspect ratio.',
    watermarkCurrentImage: 'Current watermark image is active',
    watermarkOpacity: 'Opacity',
    watermarkOpacityDesc: 'Watermark transparency (0-100%)',
    watermarkSize: 'Size',
    watermarkSizeDesc: 'Watermark size as percentage of image width (5-50%)',
    watermarkPreview: 'Watermark Preview',
    watermarkPreviewDesc: 'Preview on real car image from database',
    watermarkShowPreview: 'Show Preview',
    watermarkLoadingCar: 'Loading car image...',
    watermarkGenerating: 'Generating preview...',
    watermarkPreviewError: 'Failed to load preview image',
    watermarkPreviewErrorHelp: 'The preview will use client-side watermarking as fallback.',
    watermarkPreviewFallback: 'Using original image - watermark preview unavailable',
    watermarkDisabled: 'Watermark is disabled. Enable it to see the preview.',
    watermarkPreviewNote: 'This preview uses a real car image from your database and shows exactly how the watermark will appear on your site.',
    
    // Actions
    save: 'Save Settings',
    saving: 'Saving...',
    saved: 'Settings saved successfully',
    error: 'Error saving settings',
    
    // Pagination
    showing: 'Showing',
    to: 'to',
    of: 'of',
    results: 'results',
    perPage: 'per page'
  },

  // Brands & Models Management
  brandsModels: {
    title: 'Brands & Models Management',
    subtitle: 'Manage car brands and models',
    brands: 'Brands',
    models: 'Models',
    totalBrands: 'Total Brands',
    totalModels: 'Total Models',
    
    // Brand management
    brandName: 'Brand Name',
    logoUrl: 'Logo URL',
    modelCount: 'Model Count',
    createdAt: 'Created At',
    addBrand: 'Add Brand',
    editBrand: 'Edit Brand',
    deleteBrand: 'Delete Brand',
    addBrandDescription: 'Add a new car brand to the system',
    editBrandDescription: 'Edit the selected car brand',
    deleteBrandConfirm: 'Are you sure you want to delete the brand "{{name}}"? This action cannot be undone.',
    brandNamePlaceholder: 'Enter brand name (e.g., Toyota)',
    logoUrlPlaceholder: 'Enter logo URL (optional)',
    logoUrlHelp: 'Enter a valid URL to the brand logo image',
    searchBrands: 'Search brands...',
    noBrands: 'No brands found',
    
    // Model management
    modelName: 'Model Name',
    brand: 'Brand',
    yearRange: 'Year Range',
    yearStart: 'Year Start',
    yearEnd: 'Year End',
    addModel: 'Add Model',
    editModel: 'Edit Model',
    deleteModel: 'Delete Model',
    addModelDescription: 'Add a new car model to the system',
    editModelDescription: 'Edit the selected car model',
    deleteModelConfirm: 'Are you sure you want to delete the model "{{name}}"? This action cannot be undone.',
    modelNamePlaceholder: 'Enter model name (e.g., Camry)',
    selectBrand: 'Select a brand',
    filterByBrand: 'Filter by brand',
    allBrands: 'All Brands',
    searchModels: 'Search models...',
    noModels: 'No models found',
    yearRangeHelp: 'Leave empty if the model is still in production',
    preSelectedBrand: 'Pre-selected brand',
    
    // Models Dialog
    modelsDialog: {
      title: '{{brandName}} - Models',
      description: 'Manage models for {{brandName}}',
      addModel: 'Add Model',
      noModels: 'No models for this brand',
      modelsList: 'Models List'
    },
    modelsCount: '{{count}} Models',
    viewModels: 'View Models',
    
    // Success messages
    success: {
      brandCreated: 'Brand created successfully',
      brandUpdated: 'Brand updated successfully',
      brandDeleted: 'Brand deleted successfully',
      modelCreated: 'Model created successfully',
      modelUpdated: 'Model updated successfully',
      modelDeleted: 'Model deleted successfully'
    },
    
    // Error messages
    errors: {
      fetchBrands: 'Failed to fetch brands',
      fetchModels: 'Failed to fetch models',
      createBrand: 'Failed to create brand',
      updateBrand: 'Failed to update brand',
      deleteBrand: 'Failed to delete brand',
      createModel: 'Failed to create model',
      updateModel: 'Failed to update model',
      deleteModel: 'Failed to delete model',
      saveBrand: 'Failed to save brand',
      saveModel: 'Failed to save model',
      brandHasModels: 'Cannot delete brand that has associated models'
    },
    
    // Validation messages
    validation: {
      nameRequired: 'Brand name is required',
      modelNameRequired: 'Model name is required',
      brandRequired: 'Brand selection is required',
      invalidUrl: 'Please enter a valid URL',
      yearEndMustBeAfterStart: 'End year must be after start year',
      invalidYearStart: 'Invalid start year',
      invalidYearEnd: 'Invalid end year'
    }
  },

  // WhatsApp Action Settings
  whatsapp: {
    actions: {
      title: 'Notification Actions',
      description: 'Control which actions trigger WhatsApp notifications and select templates for each action',
      new_booking: {
        name: 'New Booking Received',
        description: 'Notify agency owner when a new booking is created'
      },
      booking_confirmed: {
        name: 'Booking Confirmed',
        description: 'Notify agency owner when a booking is confirmed'
      },
      booking_cancelled: {
        name: 'Booking Cancelled',
        description: 'Notify agency owner when a booking is cancelled'
      },
      client_registered: {
        name: 'New Client Registered',
        description: 'Notify agency owner when a new client is registered'
      },
      vehicle_added: {
        name: 'Vehicle Added',
        description: 'Notify agency owner when a vehicle is added to fleet'
      },
      vehicle_removed: {
        name: 'Vehicle Removed',
        description: 'Notify agency owner when a vehicle is removed from fleet'
      },
      payment_reminder: {
        name: 'Payment Reminder',
        description: 'Send payment reminders to customers'
      },
      selectTemplate: 'Select template',
      saveActions: 'Save Actions',
      saving: 'Saving...',
      actionsSaved: 'Action settings saved successfully',
      actionsSaveError: 'Failed to save action settings'
    }
  }
};